import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { faGenderless, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

export const icons = [faCheckCircle, faTimesCircle, faGenderless, faExclamationCircle];

library.add(icons);

export { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';
